import { render, staticRenderFns } from "./CargoShow.vue?vue&type=template&id=34f884d2&scoped=true&"
import script from "./CargoShow.vue?vue&type=script&lang=js&"
export * from "./CargoShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f884d2",
  null
  
)

export default component.exports